import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'typeOfPersonelPipe'
})
export class TypeOfPersonelPipe implements PipeTransform {

  transform(value: any): any {
    let nameRespone = '';
    switch (value) {
      case 1:
        nameRespone = 'positionName';
        break;
      case 2:
        nameRespone = 'positionGVName';
        break;
      case 3:
        nameRespone = 'position';
        break;
      case 4:
        nameRespone = 'position';
        break;
    }
    return nameRespone;
  }

}
